import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { icon } from 'src/consts/icon';

@Component({
  selector: 'app-dialog-content-component',
  templateUrl: './dialog-content-component.html',
  styleUrls: ['./dialog-content-component.scss'],
  standalone: false
})
export class DialogContentComponent implements OnInit {
  safeUrl: SafeResourceUrl;
  isScrolledToBottom = false;
  smartaccupay_logo: any = icon.INVOICE_LOGO;
  private scrollListener?: () => void;
  terms_and_condition: any
  privacy_policy: any
  constructor(
    private sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<DialogContentComponent>,
    private renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) public data: { type: string; url: string, planData: any }
  ) {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.url);
    this.terms_and_condition = this.sanitizer.bypassSecurityTrustHtml(data.planData.terms_and_condition);
    this.privacy_policy = this.sanitizer.bypassSecurityTrustHtml(data.planData.privacy_policy);
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    const dialogContent = document.querySelector('.mat-dialog-content') as HTMLElement;

    if (dialogContent) {
      this.scrollListener = this.renderer.listen(dialogContent, 'scroll', () => {
        const isAtBottom =
          dialogContent.scrollTop + dialogContent.clientHeight >= dialogContent.scrollHeight;
        this.isScrolledToBottom = isAtBottom;

        if (isAtBottom) {
          this.loadMoreContent();
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.scrollListener) {
      this.scrollListener();
    }
  }

  loadMoreContent(): void {
    // Simulate API call or data fetching
    this.isScrolledToBottom = true;
  }

  onScroll(): void {
    this.loadMoreContent();
  }

  setHeightStyles(): { [key: string]: string } {
    return {
      height: '400px',
      overflow: 'auto',
    };
  }

  accept(): void {
    this.dialogRef.close('accepted');
  }
}
